import { MEDIA } from "../i18n";
import Reveal from "./Reveal";

export default function About({ t }) {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-28 md:py-40 bg-[#FDFBF7] relative"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-14 items-start">
        <div className="lg:col-span-5">
          <Reveal>
            <div className="img-frame aspect-[4/5]">
              <img src={MEDIA.candles} alt="Danwei Huang" />
            </div>
          </Reveal>
          <Reveal delay={180}>
            <div className="mt-4 bg-[#F5EFE6] aspect-[2/1] flex items-center gap-6 p-8 border border-[#E8E1D9]">
              <span className="font-chinese text-7xl text-[#C99A4E] leading-none">
                源
              </span>
              <div className="flex flex-col gap-1">
                <span className="overline">Yuan · Origin</span>
                <span className="font-serif italic text-xl text-[#3E362E]">
                  La fuente
                </span>
                <span className="text-sm text-[#7D746A]">本源 · 源头</span>
              </div>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-6 lg:col-start-7">
          <Reveal>
            <span className="overline" data-testid="about-overline">
              {t.about.overline}
            </span>
          </Reveal>
          <Reveal delay={120}>
            <h2
              className="font-serif text-5xl md:text-6xl lg:text-7xl mt-5 leading-[0.98] text-[#3E362E]"
              data-testid="about-title"
            >
              {t.about.title}
            </h2>
          </Reveal>
          <Reveal delay={220}>
            <p className="mt-4 font-serif italic text-xl text-[#1A9BC1]">
              {t.about.role}
            </p>
          </Reveal>
          <Reveal delay={340}>
            <p className="mt-8 text-[#5E554C] text-lg font-light leading-relaxed">
              {t.about.body}
            </p>
          </Reveal>

          <Reveal delay={480}>
            <blockquote
              className="mt-14 pl-8 border-l-2 border-[#C99A4E]"
              data-testid="about-quote"
            >
              <p className="testimonial-quote text-2xl md:text-3xl leading-tight text-[#3E362E]">
                {t.about.quote}
              </p>
              <footer className="mt-6 text-sm tracking-widest uppercase text-[#8D7B68]">
                {t.about.quoteAuthor}
              </footer>
            </blockquote>
          </Reveal>

          <Reveal delay={600}>
            <div className="mt-12 grid grid-cols-3 gap-6">
              {(t.about.stats || []).map((stat, idx) => (
                <div
                  key={stat.n}
                  className={`border-t pt-4 ${
                    idx === 1 ? "border-[#C99A4E]" : "border-[#CEBFAA]"
                  }`}
                  data-testid={`about-stat-${stat.n}`}
                >
                  <div
                    className={`font-serif text-3xl md:text-4xl ${
                      idx === 1 ? "text-[#C99A4E]" : "text-[#3E362E]"
                    }`}
                  >
                    {stat.n}
                  </div>
                  <div className="text-sm text-[#8D7B68] mt-1 tracking-wide">
                    {stat.d}
                  </div>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
